import { nest } from 'utils/pathHelpers'

// query params
export const SIDEBAR_QUERY_PARAM_KEY = 'sidebar'

// paths

export const ADMIN_PATH = '/admin'
export const BILLING_PATH = '/billing'
export const FLIPPER_PATH = '/flipper'
export const SIDEKIQ_PATH = '/sidekiq'
export const MAINTENANCE_PATH = '/maintenance'

export const MEDIA_FILE_PATH = '/media_files/:key'
export const DOC_PATH = '/docs/:slug'
export const DOC_ACTIVITY_PATH = nest(DOC_PATH, '/activity/:eventId?')
export const DOC_HISTORY_PATH = nest(DOC_PATH, '/history/:eventIdA?/:eventIdB?')
export const DOC_ACTIVITY_BRANCH_PATH = nest(DOC_PATH, '/activity/:eventId/branch/:parent_version?')
export const DOC_INSIGHTS_PATH = nest(DOC_PATH, '/insights')
export const DOC_COMPARE_PATH = nest(DOC_PATH, '/compare/:eventIdA?/:eventIdB?')
export const DOC_BRANCH_PATH = nest(DOC_PATH, '/branch/:parent_version?')
export const FOLDER_ROUTE_PATH = '/folders/:folderSlug'
export const FOLDER_DOC_PATH = nest(FOLDER_ROUTE_PATH, '/:doc')
export const FOLDER_DOC_INSIGHTS_PATH = nest(FOLDER_DOC_PATH, '/insights')
export const FOLDER_PATH = nest(FOLDER_ROUTE_PATH, '/:doc?/:rest*')
export const FOLDER_SETTINGS_PATH = nest(FOLDER_ROUTE_PATH, '/settings')
export const FOLDER_TEMPLATES_PATH = nest(FOLDER_ROUTE_PATH, '/:doc?/:rest*/templates')
export const FOLDER_VIEWS_PATH = nest(FOLDER_ROUTE_PATH, '*/views/:view?')
export const FOLDER_SUBFOLDER_PATH = nest(FOLDER_ROUTE_PATH, '/folder_:subfolderKey')
export const HANDBOOK_PATH = '/handbook/:folderSlug/:doc?/:rest*'
export const HANDBOOK_DOC_PATH = '/handbook/:folderSlug/:doc'
export const PDF_DOC_PATH = nest(DOC_PATH, '/pdf')
export const CONTRIBUTORS_PATH = '/contributors'
export const CORE_PATH = '/home'
export const SAML_PATH = '/saml-auth'
export const GOOGLE_PATH = '/google-auth'
export const FACEBOOK_PATH = '/facebook-auth'
export const APPLE_PATH = '/apple-auth'
export const APPLE_OAUTH_CALLBACK_PATH = '/oauth/apple/callback'
export const PAYMENT_STATUS_PATH = '/payment-status'
export const CHECKOUT_SESSION_PATH = '/checkout-session'
export const HOME_PATH = '/'
export const INSTAGRAM_PLANNING_PATH = '/ig-planning'
export const EXTERNAL_TEMPLATES_PATH = '/templates/:format?'
export const GITHUB_APP_REDIRECT_PATH = '/github_redirect'
export const JIRA_OAUTH_REDIRECT_PATH = '/jira_oauth_redirect'
export const X_OAUTH_REDIRECT_PATH = '/x_oauth_redirect'
export const LINKEDIN_OAUTH_REDIRECT_PATH = '/linkedin_oauth_redirect'
export const INSTAGRAM_OAUTH_REDIRECT_PATH = '/instagram_oauth_redirect'
export const FACEBOOK_OAUTH_REDIRECT_PATH = '/facebook_oauth_redirect'
export const OAUTH_V2_REDIRECT_PATH = '/oauth/:provider/callback'
export const LOGIN_PATH = '/login'
export const FORGOT_PASSWORD_PATH = '/forgot'
export const SIGNUP_PATH = '/signup'
export const LOGIN_OR_SIGNUP_PATH = '/login_or_signup'
export const CREATE_WORKSPACE_PATH = '/create_workspace'
export const CREATE_ACCOUNT_PATH = '/create_account'
export const START_FREE_TRIAL_PATH = '/start_free_trial'
export const SCHEDULE_DEMO_PATH = '/schedule_demo'
export const WAITING_LIST_PATH = '/waiting_list'
export const DEMO_SCHEDULED_PATH = '/demo_scheduled'
export const SELECT_ROLE_PATH = '/select_role'
export const COMPANY_DATA_PATH = '/company_data'
export const NEW_WORKSPACE_PATH = '/workspace/new'
export const REQUESTED_DOCS_PATH = '/requested-docs'
export const SUPPORTERS_PATH = '/supporters'
export const WORKSPACE_SELECTION_PATH = '/workspaces'
export const SELECT_WORKSPACE_PATH = '/select-workspace'
export const WORKSPACE_GROUPS_PATH = '/workspace/groups'
export const WORKSPACE_JOIN_REQUEST_PATH = '/workspace_join_requests/:token/:action'
export const PROFILE_PATH = '/users/:id/:slug/:tab?'
export const WORKSPACE_URL_JOIN = '/invite/workspace/:slug'
export const PRODUCT_PATH = '/product'
export const PASSWORD_RESET_PATH = '/password-reset'
export const EDITOR_SANDBOX_PATH = '/editor-demo'
export const ASANA_OAUTH_REDIRECT = '/asana/connect'
export const SLACK_OAUTH_REDIRECT = '/slack/connect'
export const SLACK_APP_REDIRECT = `https://slack.com/app_redirect?app=${process.env.REACT_APP_SLACK_APP_ID}`
export const ASANA_APP_REDIRECT = `https://asana.com`
export const QUICK_IMPORT_PATH = '/import'
export const PAYWALL_START_FREE_TRIAL_PATH = '/start-free-trial'
export const PAYWALL_SUBSCRIBE_PATH = '/subscribe'

// Marketing paths
export const ABOUT_PATH = '/about'
export const ABOUT_ASYNC_REVIEW_PATH = '/about-the-async-review'
export const ASYNC_REVIEW_PATH = '/async-review'
export const BLOG_PATH = '/blog'
export const BLOG_POSTS_PATH = '/blog-posts/:slug'
export const BLOG_CATEGORIES_PATH = '/blog-categories/:slug'
export const CAREERS_PATH = '/careers'
export const CHANGELOG_PATH = '/changelog'
export const COMPANY_HANDBOOK_PATH = '/company-handbook'
export const COMPARE_CODA_PATH = '/compare/coda-alternative'
export const COMPARE_CONFLUENCE_PATH = '/compare/confluence-alternative'
export const COMPARE_GOOGLE_DOCS_PATH = '/compare/google-docs-alternative'
export const COMPARE_MICROSOFT_WORD_PATH = '/compare/microsoft-word-alternative'
export const COMPARE_NOTION_PATH = '/compare/notion-alternative'
export const CONTACT_SALES_PATH = '/contact-sales'
export const CUSTOMERS_PATH = '/customers'
export const DEMO_PATH = '/demo'
export const FEATURES_PATH = '/features'
export const FOR_COMPLIANCE_MANAGEMENT_PATH = '/for/compliance-management'
export const FOR_CONTRACT_MANAGEMENT_PATH = '/for/contract-management'
export const FOR_DOCUMENTATION_PATH = '/for/documentation'
export const FOR_ENTERPRISE_PATH = '/for/enterprise'
export const FOR_ENGINEERING_TEAMS_PATH = '/for/engineering-teams'
export const FOR_INTERNAL_COLLABORATION_PATH = '/for/internal-collaboration'
export const FOR_PUBLIC_DOCUMENTATION_PATH = '/for/public-documentation'
export const FORM_PATH = '/form'
export const INVESTORS_PATH = '/investors'
export const INTEGRATIONS_PATH = '/integrations'
export const MAGAZINE_PATH = '/magazine'
export const MAGAZINE_POSTS_PATH = '/magazine-posts/:slug'
export const MAGAZINE_CATEGORIES_PATH = '/magazine-categories/:slug'
export const MWM_PATH = '/modern-work-method'
export const KICKOFF_PATH = '/kickoff'
export const PRICING_PATH = '/pricing'
export const PRIVACY_POLICY_PATH = '/privacy-policy'
export const PRESS_PATH = '/press'
export const RESERVE_PATH = '/reserve'
export const REMOTE_TEAMS_PATH = '/for/remote-teams'
export const SCHEDULE_PATH = '/schedule'
export const FOR_STARTUPS_PATH = '/for/startups'
export const TERMS_PATH = '/terms'
export const THANK_YOU_PATH = '/thank-you'
export const HOME_ALTERNATIVE_PATH = '/alt'

// workspace dashboard
export const WORKSPACE_PATH = '/workspaces/:workspaceId'
export const WORKSPACE_IMPORT_PATH = nest(WORKSPACE_PATH, '/import')

// blaze paths
export const BLAZE_HOME_PATH = nest(WORKSPACE_PATH, '/home')

export const ACADEMY_PATH = nest(WORKSPACE_PATH, '/academy')
export const ARCHIVE_PATH = nest(WORKSPACE_PATH, '/archive')
export const GROUPS_PATH = nest(WORKSPACE_PATH, '/groups')
export const GROUP_PATH = nest(GROUPS_PATH, '/:id')
export const TODOS_PATH = nest(WORKSPACE_PATH, '/todos')
export const BRAIN_PLAYGROUND_PATH = nest(WORKSPACE_PATH, '/brain')
export const VISUAL_STYLES_PLAYGROUND_PATH = nest(WORKSPACE_PATH, '/visual-styles-playground')
export const BRAND_KITS_PATH = nest(WORKSPACE_PATH, '/brand-kits')
export const BRAND_KIT_PATH = nest(BRAND_KITS_PATH, '/:id')
export const CONTENT_PREFERENCES_PATH = nest(WORKSPACE_PATH, '/content-preferences')
export const BRAND_PLAN_PATH = nest(WORKSPACE_PATH, '/brand-plan')
export const VIRTUAL_MARKETER_PLAYGROUND_PATH = nest(WORKSPACE_PATH, '/vm-playground')
export const VIRTUAL_MARKETER_ONBOARDING_PATH = nest(WORKSPACE_PATH, '/virtual-marketer-onboarding')
export const VIRTUAL_MARKETER_ONBOARDING_TEST_PATH = nest(WORKSPACE_PATH, '/vm-onboarding-test')
export const RECENT_DOCS_PATH = nest(WORKSPACE_PATH, '/recent')
export const SHARED_WITH_ME_DOCS_PATH = nest(WORKSPACE_PATH, '/shared_with_me')
export const ALL_FILES_PATH = nest(WORKSPACE_PATH, '/all_files/:location?')
export const FAVORITES_PATH = nest(WORKSPACE_PATH, '/favorites')
// The path all_docs is deprecated and changed to all_files
export const ALL_DOCS_PATH_DEPRECATED = nest(WORKSPACE_PATH, '/all_docs')
export const IMPORT_STATE_PATH = nest(WORKSPACE_PATH, '/import/:key')
export const WORKSPACE_ARTICLE_STYLE_PATH = nest(WORKSPACE_PATH, '/article_style')
export const MEMBERS_PATH = nest(WORKSPACE_PATH, '/members')
export const HANDBOOKS_PATH = nest(WORKSPACE_PATH, '/handbooks')
export const SCHEDULED_POSTS_PATH = nest(WORKSPACE_PATH, '/scheduled-posts')
export const PAID_ADS_PATH = nest(WORKSPACE_PATH, '/paid-ads')
export const PAID_ADS_WIZARD_PATH = nest(PAID_ADS_PATH, '/wizard/:campaignId?')
export const UPLOADS_PATH = nest(WORKSPACE_PATH, '/uploads')
export const UPLOADS_VIEWS_PATH = nest(UPLOADS_PATH, '*/views/:view?')
export const ANALYTICS_PATH = nest(WORKSPACE_PATH, '/analytics')
export const AUTOPILOT_INTEGRATIONS_PATH = nest(WORKSPACE_PATH, '/integrations')
export const ANNUAL_UPGRADE_PATH = nest(WORKSPACE_PATH, '/annual-upgrade')
export const WIZARD_PATH = nest(WORKSPACE_PATH, '/wizard')
export const NATIVE_WEBVIEW_BRAND_KIT_PATH = nest(WORKSPACE_PATH, '/native_webview_brand_kit')
export const BRAND_PLAN_SCHEDULE_PATH = nest(WORKSPACE_PATH, '/schedules/:scheduleId')
export const CAMPAIGNS_PATH = nest(WORKSPACE_PATH, '/campaigns')
export const CONTENT_PLAN_PATH = nest(WORKSPACE_PATH, '/content-plan')
export const CAMPAIGN_PATH = nest(CAMPAIGNS_PATH, '/:campaignId')
export const APPROVALS_PATH = nest(WORKSPACE_PATH, '/approvals')
export const CONTENT_PLAN_SCHEDULE_PATH = nest(CONTENT_PLAN_PATH, '/:scheduleId')


export const WRITE_PATH = '/write'
export const SUGGESTION_MANUAL_MERGE = nest(DOC_PATH, '/suggestions/:suggestionId/merge')
export const EXPORT_PATH = '/export/:contentId/:schema_version/:format'
export const PREVIEW_PATH = '/preview/:jwt/:schema_version/:format'
export const HIGHLIGHT_PREVIEW_PATH = '/highlight-preview/:uuid'
export const ARTICLE_DEBUG_PATH = '/article-debug'
export const AUTH_REDIRECT_PATH = '/auth-redirect'
export const REFERRALS_PATH = '/referrals'
export const REGISTRATION_PATH = '/registration'
export const AUTOPILOT_REGISTRATION_PATH = '/apstart-cHN4Pc84'

// Merge
export const MERGE_PATH = '/merge/:docAId/:docBId'
export const MERGE_LAYER_PATH = '/docs/:slug/layers/:layerId/merge'

// Widget Paths
export const WIDGET_GOOGLE_OAUTH_PATH = '/widgets/google_oauth'

/**
 * AI Wizards
 */
export const WIZARDS_PATH = '/create'
export const BLOG_POST_WIZARD_PATH = nest(WIZARDS_PATH, '/blog-post')
export const NURTURE_EMAIL_SEQUENCE_WIZARD_PATH = nest(WIZARDS_PATH, '/nurture-email-sequence')
export const PROMO_EMAIL_SEQUENCE_WIZARD_PATH = nest(WIZARDS_PATH, '/promo-email-sequence')

/**
 * Reviews Paths
 */
export const ARTICLE_REVIEW_PATH = nest(DOC_PATH, '/reviews/:reviewId')
export const ARTICLE_NEW_REVIEW_PATH = nest(DOC_PATH, '/reviews/new')
export const ARTICLE_DISMISS_REVIEW_PATH = nest(DOC_PATH, '/reviews/:reviewId/dismiss')
export const ARTICLE_SUBMIT_REVIEW_PATH = nest(DOC_PATH, '/reviews/:reviewId/submit')
export const ARTICLE_CANCEL_REVIEW_PATH = nest(DOC_PATH, '/reviews/:reviewId/cancel')
export const ARTICLE_CLOSE_REVIEW_PATH = nest(DOC_PATH, '/reviews/:reviewId/close')
export const ARTICLE_CANCEL_AND_MERGE_REVIEW_PATH = nest(DOC_PATH, '/reviews/:reviewId/cancel_and_merge')
export const ARTICLE_ENDED_REVIEW_PATH = nest(DOC_PATH, '/reviews/:reviewId/ended')
/**
 * Reviews Paths (when viewing the doc in a folder)
 */
export const FOLDER_ARTICLE_REVIEW_PATH = nest(FOLDER_DOC_PATH, '/reviews/:reviewId')
export const FOLDER_ARTICLE_NEW_REVIEW_PATH = nest(FOLDER_DOC_PATH, '/reviews/new')
export const FOLDER_ARTICLE_DISMISS_REVIEW_PATH = nest(FOLDER_DOC_PATH, '/reviews/:reviewId/dismiss')
export const FOLDER_ARTICLE_SUBMIT_REVIEW_PATH = nest(FOLDER_DOC_PATH, '/reviews/:reviewId/submit')
export const FOLDER_ARTICLE_CANCEL_REVIEW_PATH = nest(FOLDER_DOC_PATH, '/reviews/:reviewId/cancel')
export const FOLDER_ARTICLE_CLOSE_REVIEW_PATH = nest(FOLDER_DOC_PATH, '/reviews/:reviewId/close')
export const FOLDER_ARTICLE_CANCEL_AND_MERGE_REVIEW_PATH = nest(FOLDER_DOC_PATH, '/reviews/:reviewId/cancel_and_merge')
export const FOLDER_ARTICLE_ENDED_REVIEW_PATH = nest(FOLDER_DOC_PATH, '/reviews/:reviewId/ended')

/**
 * Design Paths
 */
export const DESIGN_PATH = '/designs/:key'
export const TEMPLATE_BINDERS_PATH = nest(WORKSPACE_PATH, '/template-binders')
export const TEMPLATES_PATH = nest(WORKSPACE_PATH, '/templates/:templateId?')

/**
 * Help Center Paths
 */

export const BLAZE_ZAPIER_INTEGRATION_HELP_CENTER_URL =
  'https://help.blaze.ai/en/articles/9612604-connect-blaze-to-zapier'

export const BLAZE_WORDPRESS_PLUGIN_HELP_CENTER_URL =
  'https://help.blaze.ai/en/articles/9556383-connect-blaze-to-wordpress'
